



























import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Model } from "vue-property-decorator";
import SelectBox, { ISelectBox } from "@/components/atoms/SelectBox.vue";
import Utils from "@/common/utils";
import _ from "lodash";

@Component({
  components: { SelectBox },
})
export default class InputYearMonth extends Vue {
  name: "InputYearMonth";

  @Model("set-target-year-month", { type: String, default: null })
  targetYearMonth: string | null;

  @Prop({ required: true })
  public yearLabelName!: string;

  @Prop({ required: true })
  public yearFrom!: number;

  @Prop({ required: true })
  public yearTo!: number;

  @Prop({ required: true })
  public monthLabelName!: string;

  get targetYear() {
    return _.isString(this.targetYearMonth)
      ? this.targetYearMonth.substr(0, 4)
      : "";
  }
  set targetYear(value: string) {
    this.$emit("set-target-year-month", value + this.targetMonth);
  }

  get targetMonth() {
    return _.isString(this.targetYearMonth)
      ? this.targetYearMonth.substr(4, 2)
      : "";
  }
  set targetMonth(value: string) {
    this.$emit("set-target-year-month", this.targetYear + value);
  }

  get yearList(): ISelectBox[] {
    const yearList: ISelectBox[] = [];
    for (let year = this.yearFrom; year <= this.yearTo; year++) {
      const yearStr = String(year);
      yearList.push({
        key: yearStr,
        innerValue: yearStr,
        diaplayValue: yearStr,
      });
    }
    return yearList;
  }

  get monthList(): ISelectBox[] {
    const monthList: ISelectBox[] = [];
    const startMonth = 1;
    const endMonth = 12;
    for (let month = startMonth; month <= endMonth; month++) {
      const monthStr = Utils.getZeroPadding(String(month), 2);
      monthList.push({
        key: monthStr,
        innerValue: monthStr,
        diaplayValue: monthStr,
      });
    }
    return monthList;
  }
}
